export class PosConfig {
  showTopSales?: boolean;
  topSalesLimit?: number;

  filterByBrand?: boolean;
  filterByCategory?: boolean;
  filterBySupplier?: boolean;

  automaticallyAddToCart?: boolean;
  showProductImages?: boolean;
  scanSound?: boolean;

  constructor() {
    this.filterByBrand = false;
    this.showTopSales = true;
    this.topSalesLimit = 18;
    this.filterByCategory = true;
    this.filterBySupplier = false;
    this.automaticallyAddToCart = true;
    this.showProductImages = true;
    this.scanSound = true;
  }
}
